"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatusEffect = void 0;
var react_1 = require("react");
var useStatusEffect = function (_a) {
    var fetchState = _a.fetchState, reliablePartnerStatusCheck = _a.reliablePartnerStatusCheck, reliablePartnerReportStatus = _a.reliablePartnerReportStatus, reliablePartnerStatusFailure = _a.reliablePartnerStatusFailure, reliablePartnerFetchStatus = _a.reliablePartnerFetchStatus, setBannerStatus = _a.setBannerStatus, setFetchState = _a.setFetchState, setBannerText = _a.setBannerText, setShowBanner = _a.setShowBanner;
    var updateStatus = (0, react_1.useCallback)(function (status, bannerText) {
        if (bannerText)
            setBannerText(bannerText);
        setFetchState(status);
        setBannerStatus(status);
        setShowBanner(true);
    }, [setFetchState, setBannerText, setShowBanner]);
    var setStatusNotChanged = function () {
        var status = reliablePartnerFetchStatus === 'FAILED' ? 'FAILED' : 'INFO';
        var message = reliablePartnerFetchStatus === 'FAILED' ? 'FAILED' : 'STATUS_NOT_CHANGED';
        updateStatus(status, message);
    };
    (0, react_1.useEffect)(function () {
        if (fetchState === 'FETCHED') {
            var isStatusChanged = reliablePartnerStatusCheck.isStatusChanged, value = reliablePartnerStatusCheck.value;
            var _a = reliablePartnerStatusFailure.error, type = _a.type, message = _a.message;
            if (type === 'THROTTLED_ERROR') {
                updateStatus('WARNING', 'THROTTLED_ERROR');
            }
            else if (['UNAVAILABLE', 'BUSINESS_ID_MISSING'].includes(value)) {
                updateStatus('WARNING', value);
            }
            else if (reliablePartnerReportStatus === 'FETCHED') {
                updateStatus('FETCHED', 'FETCHED');
            }
            else if (isStatusChanged === false) {
                setStatusNotChanged();
            }
            else if (type === 'FAILED' ||
                reliablePartnerReportStatus === 'FAILED') {
                updateStatus('FAILED', message === 'NOT_FOUND' ? message : 'FAILED');
            }
        }
        var timer = setTimeout(function () { return setFetchState('IDLE'); }, 1000);
        return function () { return clearTimeout(timer); };
    }, [
        fetchState,
        reliablePartnerStatusCheck,
        reliablePartnerReportStatus,
        reliablePartnerStatusFailure,
        reliablePartnerFetchStatus,
        updateStatus,
        setFetchState
    ]);
};
exports.useStatusEffect = useStatusEffect;
